window.Text = function () {
    var el = this;

    var elsList = {};
    var isMoving = false;
    var isRotating = false;
    el.fonts = {};
    
    el.cutArea = {x: 0, y: 0, width: 0, height: 0};

    function initCutArea() {
        el.cutArea = {
            x1: 0,
            y1: 0,
            x2: el.workData.workareas[el.selectWorkareaId].width,
            y2: el.workData.workareas[el.selectWorkareaId].height
        };
    }

    function checkCutArea(element, movementX, movementY) {
        var boxPos = el.transform.getArea(element);

        if (boxPos.x1 + movementX < el.cutArea.x1 && movementX < 0) {
            return false;
        }

        if (boxPos.y1 + movementY < el.cutArea.y1 && movementY < 0) {
            return false;
        }

        if (boxPos.x2 + movementX > el.cutArea.x2 && movementX > 0) {
            return false;
        }

        if (boxPos.y2 + movementY > el.cutArea.y2 && movementY > 0) {
            return false;
        }

        return true;
    }

    el.add = function () {
        var keys = Object.keys(el.workData.workareas[el.selectWorkareaId].texts);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var text = {
            x: 100,
            y: 100,
            font_family: el.fonts[0].name,
            font_size: '20px',
            text_anchor: 'start',
            fill: '#000',
            id: number,
            rows: [
                {x: 100, y: 100, text: 'Новый текст'}
            ]
        };

        el._parent.workData.workareas[el.selectWorkareaId].texts[number] = text;

        el.workarea.render();
        el.history.add();

        el.selection.show(document.getElementById('text-item-' + el.selectWorkareaId + '-' + number), el.selectWorkareaId, 'text');
    };

    el.copy = function () {
        var reversal = el._parent.workData.workareas[el.selectWorkareaId];
        var keys = Object.keys(reversal.texts);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var text = $.extend(true, {}, reversal.texts[el.selectId]);
        text.id = number;
        text.x = parseInt(el.workData.width / 2);
        text.y = parseInt(el.workData.height / 2);

        text.text = '';
        var i;
        var y = text.y;
        for (i in text.rows) {
            text.rows[i].x = text.x;
            text.rows[i].y = y;
            y += parseInt(text.font_size);
        }

        reversal.texts[number] = text;

        el.workarea.render();
        el.history.add();

        el.selection.show(document.getElementById('text-item-' + el.selectWorkareaId + '-' + number), el.selectWorkareaId, 'text');
    };

    el.remove = function () {
        var element = el.svgRoot.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);
        element.parentNode.removeChild(element);
        delete el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId];

        el.selection.hide();
        el.history.add();

    };

    el.removeDefaultTexts = function () {
        Object.keys(el._parent.workData.workareas).forEach(function(WorkareaId) {
            if(typeof el._parent.workData.workareas[WorkareaId] !== 'object' || el._parent.workData.workareas[WorkareaId] === null) {
                return true;
            }
            if(!el._parent.workData.workareas[WorkareaId].hasOwnProperty('texts')) {
                return true;
            }
            
            Object.keys(el._parent.workData.workareas[WorkareaId].texts).forEach(function(selectId) {
                if (typeof el._parent.workData.workareas[WorkareaId].texts[selectId] !== 'object'
                || el._parent.workData.workareas[WorkareaId].texts[selectId] === null){
                    return true;
                }
                var text = el._parent.workData.workareas[WorkareaId].texts[selectId]
                if (!text.hasOwnProperty('rows')){
                    return true;
                }
                    
                if (el._parent.workData.workareas[WorkareaId].texts[selectId].rows[0].text == 'Новый текст') {
                    el.selectWorkareaId =  WorkareaId;
                    el.selectId = selectId;

                    delete el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId];
                    el.selection.hide();
                    el.history.add();
                } 
            })    
            
        });
    };

    el.beginMove = function () {
        isMoving = true;
        el._parent.isTransforming = true;
        var element = el.svgRoot.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);
        
        elsList = {
            element: element,
            children: $(element).children(),
            coord: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0
        };
        
        initCutArea();
    };

    el.move = function (event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }
            
            var element = elsList.element;
            
            if (!checkCutArea(element, movementX, movementY)) {
                return false;
            }
            
            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var reversal = el._parent.workData.workareas[el.selectWorkareaId];

            var pos = {
                x: parseInt(elsList.coord.x + elsList.x),
                y: parseInt(elsList.coord.y + elsList.y)
            };
            
            el.transform.setPosition(element, pos.x, pos.y);
            reversal.texts[el.selectId].x = pos.x;
            reversal.texts[el.selectId].y = pos.y;

            var i, diifY = parseInt(reversal.texts[el.selectId].font_size);
            for (i = 0; i < elsList.children.length; i++) {
                el.transform.setPosition(elsList.children[i], pos.x, pos.y);
                reversal.texts[el.selectId].rows[i].x = pos.x;
                reversal.texts[el.selectId].rows[i].y = pos.y;
                pos.y += diifY;
            }

            // detect transform for image
            var rotate = el.transform.getRotate(element);
            reversal.texts[el.selectId].rotate_angle = rotate.angle;
            reversal.texts[el.selectId].rotate_x = rotate.x;
            reversal.texts[el.selectId].rotate_y = rotate.y;

            el.selection.update(element);
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    el.beginRotate = function () {
        isRotating = true;
        el._parent.isTransforming = true;

        var element = el.svgRoot.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);
        var pos = element.getBBox();

        elsList = {
            element: element,
            coords: {
                x: pos.x,
                y: pos.y,
                width: pos.width,
                height: pos.height,
                centerX: pos.x + pos.width / 2,
                centerY: pos.y + pos.height / 2
            }
        };
        
        initCutArea();
    };

    el.rotate = function (event) {
        if (isRotating) {
            var element = elsList.element;
            
            if (!checkCutArea(element, 0, 0)) {
                return false;
            }

            var pos = elsList.coords;

            var workAreaScale = el.workarea.workAreaScale;

            var offsetX = 0;
            var offsetY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                var offsetPos = el.svgRoot.getBoundingClientRect();
                offsetX = event.originalEvent.touches[0].clientX - offsetPos.left;
                offsetY = event.originalEvent.touches[0].clientY - offsetPos.top;
            } else {
                var offsetPos = el.svgRoot.getBoundingClientRect();
                offsetX = event.clientX - offsetPos.left;
                offsetY = event.clientY - offsetPos.top;
            }

            var dx = pos.centerX * workAreaScale - offsetX;
            var dy = pos.centerY * workAreaScale - offsetY;
            var angle = Math.atan2(dy, dx) * 180 / Math.PI - 90;

            el.transform.setRotate(element, angle);

            var reversal = el._parent.workData.workareas[el.selectWorkareaId];
            var rotate = el.transform.getRotate(element);
            reversal.texts[el.selectId].rotate_angle = rotate.angle;
            reversal.texts[el.selectId].rotate_x = rotate.x;
            reversal.texts[el.selectId].rotate_y = rotate.y;

            el.selection.update(element);
        }
    };

    el.endRotate = function () {
        if (isRotating) {
            isRotating = false;
            el.history.add();
        }
    };

    el.applyChange = function () {
        var data = el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId];

        if (data) {
            data.font_size = $('#editor-size').val() + 'px';
            data.font_family = $('#editor-font').val();

            var i;
            var childrens = [];

            if ($('#editor-text').length > 0 && $('#editor-text').val().length > 0) {
                var textValue = removeEmojis($('#editor-text').val());
                $('#editor-text').val(textValue);
                childrens = $('#editor-text').val().split(/\n/);
                $('#editor-text').val('');
            } else {
                for (i in data.rows) {
                    childrens.push(data.rows[i].text);
                }
            }

            data.rows = [];
            var y = data.y;
            for (i in childrens) {
                data.rows.push({
                    x: data.x,
                    y: y,
                    text: childrens[i].replace(/\s/gi, ' ')
                });
                y += parseInt(data.font_size);
            }

            el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId] = data;

            el.workarea.render();

            var textElement = document.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);
            el.selection.show(textElement, el.selectWorkareaId, 'text', false);

            el.history.add();
        }
    };

    el.setColor = function (hsb, hex, rgb, element) {
        $(element).css('background-color', '#' + hex);

        var data = el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId];
        var textElement = el.svgRoot.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);

        if (data) {
            data.fill = '#' + hex;
            textElement.setAttribute('fill', data.fill);

            el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId] = data;

            el.history.add();
        }
    };
    
    el.setAlignment = function(type) {
        var data = el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId];
        
        if (data) {
            data.text_anchor = type;
            el._parent.workData.workareas[el.selectWorkareaId].texts[el.selectId] = data;

            el.workarea.render();

            var textElement = document.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);
            el.selection.show(textElement, el.selectWorkareaId, 'text');

            el.history.add();
        }
    };

    el.init = function () {
        $('#editor-color').colpick({
            color: '000000',
            submit: 0,
            onChange: el.setColor
        }).css('background-color', '#000000');

        var item = el.workData.workareas[el.selectWorkareaId].texts[el.selectId];
        $('#editor-font').val(item.font_family);
        $('#editor-size').val(parseInt(item.font_size));
        $('#editor-color').css('background-color', item.fill);
        $('.js-set-text-alignment[data-align="'+item.text_anchor+'"]').addClass('active');
    };

    el.show = function () {
        var i, text = [];
        var rows = el.workData.workareas[el.selectWorkareaId].texts[el.selectId].rows;

        for (i in rows) {
            text.push(rows[i].text);
        }

        el.dialog.show('interior_text', {content: text.join("\n")});
    };

    $(document).on('change', '.js-font-size, .js-font-family', function () {
        el.applyChange();
    });

    $(document).on('click', '.js-update-text', function () {
        el.applyChange();
    });
    
    $(document).on('click', '.js-set-text-alignment', function() {
        $('.js-set-text-alignment').removeClass('active');
        $(this).addClass('active');
        el.setAlignment($(this).attr('data-align'));
    });

    $('.js-text-add').on('click', function () {
        el.add();
    });

    $(document).on('click', '.js-show-text', function () {
        el.show();
    });
    
    $(document).on('dblclick', '.js-workarea-text', function () {
        el.show();
    });

    function removeEmojis (string) {
        var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
        return string.replace(regex, '');
    }
};